import { ImageSize } from 'types/isomorphic';
import modifiedSizeResolution from '../../../shared/modifiedSizeResolution';

/**
 * Resolve the purchased modified size for a fibo/pre-shot redownload. There is
 * no size selector on redownload, so infer the purchased resolution the same
 * way the purchase thank-you page does (purchase repo, rf_image_item.rb):
 * match the licensed size against the /download-sizes entries, else fall back
 * to the largest one. /download-sizes carries no per-order authorization
 * (every entry is Unauthorized even with an active license), so the licensed
 * sizeName is the only purchase signal available client-side.
 */
const pickLicensedFiboSize = (
  downloadSizes: ImageSize[] | undefined,
  licensedSizeName: string
): ImageSize | undefined => {
  if (!downloadSizes?.length) return undefined;
  const licensedResolution = modifiedSizeResolution(licensedSizeName);
  const matched = licensedResolution
    ? downloadSizes.find(
        (s) => modifiedSizeResolution(s.sizeName) === licensedResolution
      )
    : undefined;
  return (
    matched ??
    downloadSizes.reduce((largest, s) =>
      (s.width ?? 0) > (largest.width ?? 0) ? s : largest
    )
  );
};

export default pickLicensedFiboSize;
